import * as React from 'react';
import { Box, Button, Paper, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import store, { useAppSelector } from '../store';
import { fetchOrganizations } from '../store/reducers/organizationSlice';
import { setAuthorization, setKeys } from '../store/reducers/authorizationSlice';

function AuthView() {
  const navigate = useNavigate();
  const { isAuthorized } = useAppSelector((store) => store.authorization);

  const [cloudKeyInput, setCloudKeyInput] = useState('');
  
  const submitKeys = async () => {
    await store.dispatch(fetchOrganizations(cloudKeyInput)).then(async (resp) => {
      if (!resp.payload) {
        throw new Error('Invalid API Key');
      }

      store.dispatch(setKeys({cloudKey: cloudKeyInput}));
      }).catch((err) => {
        console.error(err);
      });
      store.dispatch(setAuthorization(true));
  };

  useEffect(() => {
    if (isAuthorized) {
      navigate('/layout/stores');
    }
  }, [isAuthorized]);
  
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#009be5',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <Paper
        sx={{
          width: 800,
          height: 700,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        elevation={3}>
          <Box sx={{
            width: '80%',
            height: '80%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'center'
          }}>
            <h2>Authorization</h2>
            <h3>Please enter your security key</h3>
            <TextField
              id="puc-password-input"
              label="PUC Key"
              type="password"
              autoComplete="current-password"
              variant="standard"
              sx={{
                width: 400
              }}
              onChange={(e) => setCloudKeyInput(e.target.value)} />
            <Button variant='contained' sx={{
                backgroundColor: '#006db3',
                marginTop: '24px'
              }}
              onClick={() => submitKeys()}>
              Submit
            </Button>
          </Box>
      </Paper>
    </Box>
  );
}

export default AuthView;
